<script setup>
import {ref} from "vue";

const props = defineProps({
  title: String,
  cards: Array,
})

const active = ref(false);
</script>

<template>
  <div :class="`accordion-item relative ${active ? 'open' : ''}`">
    <div class="circle-pink absolute"></div>
    <div class="circle-blue absolute"></div>
    <div class="accordion-item__top relative flex justify-between align-center" @click="active = !active">
      <h4 class="text-xxl">{{ title }}</h4>
      <svg :class="`accordion-item__btn ${active ? 'active' : ''}`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9294 41.9352L31.0735 41.9352C37.7426 41.9352 41.9274 37.2116 41.9274 30.527L41.9274 12.4893C41.9274 5.80468 37.7647 1.08105 31.0735 1.08105L11.9294 1.08105C5.23816 1.08105 1.07324 5.80468 1.07324 12.4893L1.07324 30.527C1.07324 37.2116 5.23816 41.9352 11.9294 41.9352Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21.4997 30.5309L21.4997 12.4844" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M29.7763 22.2197L21.4995 30.5319L13.2227 22.2197" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="accordion-item__hidden relative">
      <div
          class="accordion-card flex flex-col align-center"
          v-for="(card, index) in cards"
          :key="index"
      >
        <img :src="require(`../../assets/${card.img}`)" alt="card image" />
        <p class="text-s">{{ card.text }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.accordion-item {
  border-radius: clamp(15px, 1.042vw, 75px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #070707;
  box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  &.open {
    .accordion-item__hidden {
      max-height: clamp(500px, 34.722vw, 2500px);
      padding: 1.389vw clamp(72px, 5vw, 360px) 3.333vw clamp(42px, 2.917vw, 210px);
    }
    .accordion-item__btn {
      transform: rotate(180deg);
    }
  }
  &__hidden {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding .2s ease;
    padding: 0 clamp(72px, 5vw, 360px) 0 clamp(42px, 2.917vw, 210px);
    gap: 3.472vw;
    row-gap: 3vw;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  &__btn {
    width: clamp(40px, 2.986vw, 215px);
    min-width: clamp(40px, 2.986vw, 215px);
    height: clamp(40px, 2.986vw, 215px);
    transition: transform .4s ease;
  }
  &__top {
    z-index: 2;
    gap: 2vw;
    cursor: pointer;
    padding: clamp(36px, 2.5vw, 180px) clamp(72px, 5vw, 360px) clamp(36px, 2.5vw, 180px) clamp(42px, 2.917vw, 210px);
    h4 {
      text-transform: capitalize;
    }
  }

  .accordion-card {
    border-radius: clamp(15px, 1.042vw, 75px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: #070707;
    box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25);
    width: 100%;
    padding: clamp(18px, 1.25vw, 90px) clamp(16px, 1.111vw, 80px) clamp(26px, 1.8vw, 150px);
    height: auto;
    p {
      color: rgba(255, 255, 255, 0.70);
      text-align: center;
      margin-top: clamp(21px, 1.458vw, 105px);
    }
    img {
      width: 100%;
    }
  }

  .circle-pink {
    left: -10%;
    top: 0;
  }
  .circle-blue {
    left: 60%;
    top: -10%;
  }
}

@media (max-width: 1024px) {
  .accordion-item {
    &.open {
      .accordion-item__hidden {
        padding: 10px 30px 20px;
      }
    }
    &__top {
      padding: 30px;
    }
    &__hidden {
      padding: 0 30px;
      column-gap: 10px;
    }
  }
}

@media (max-width: 768px) {
  .accordion-item {
    &.open {
      .accordion-item__hidden {
        max-height: 100%;
        padding: 5px 43px 30px;
      }
    }
    &__top {
      padding: 32px 20px;
    }
    &__hidden {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding: 0 43px;
    }
    .accordion-card {
      max-width: 300px;
      img {
        max-width: 200px;
      }
    }
    .circle-pink {
      left: 0;
      top: -10%;
    }
    .circle-blue {
      display: none;
    }
  }
}
</style>